// Cherry Stone \u2014 in-stock catalogue
// Each stone: { name, image, bgSize (optional), bgPosition (optional) }
// Cropped source images fill the card via background-size: cover.

const asset = (path) =>
  `https://customer-assets-v7afamib.emergentagent.net/job_cherrystone-refresh/artifacts/${path}`;

export const catalogGroups = [
  {
    type: 'Marble',
    tagline: 'Metamorphic beauty, timeless veining',
    stones: [
      {
        name: 'Arabescato Arni',
        image: asset('fkxxf8sx_Arabescato%20Arni%20Cropped.png'),
      },
      {
        name: 'Black Forrest',
        image: asset('mee9fiq3_Black%20Forrest%20Cropped.png'),
      },
      {
        name: 'Breccia Capri',
        image: asset('gtrmvec2_Breccia%20Capri%20Cropped.png'),
      },
      {
        name: 'Cherry Black',
        image: asset('wztl2z7r_Cherry%20Black%20Cropped.webp'),
        // Original image is over-exposed at top; focus on the darker lower portion
        bgSize: '180% auto',
        bgPosition: 'center 85%',
      },
      {
        name: 'Deep Blue',
        image: asset('69qtehx5_Deep%20Blue%20Cropped.png'),
      },
      {
        name: 'Grey with Golden Veins',
        image: asset('e30073b4b20a322b_Polished%20Gray%20with%20Golden%20Veins.webp'),
      },
      {
        name: 'Ottoman Beige',
        image: asset('n4cev1iw_Ottoman%20Beige%20Cropped.png'),
      },
      {
        name: 'Palisandro Blu',
        image: asset('amcghohf_Palisandro%20Blu%20Cropped.png'),
      },
      {
        name: 'Red Wine',
        image: asset('5i92lhw3_Red%20Wine%20Cropped.png'),
      },
      {
        name: 'Rosa Aurora',
        image: asset('ppwsqr7p_Rosa%20Aurora%20Cropped.png'),
      },
      {
        name: 'Rosa Portogallo',
        image: asset('82paalew_Rosa%20Portogallo%20Cropped.png'),
      },
      {
        name: 'Rosso Verona',
        image: asset('sfcz82p5_Rosso%20Verona%20Cropped.png'),
      },
      {
        name: 'Verde Alpi',
        image: asset('qjh656te_Verde%20Alpi%20Cropped.png'),
      },
      {
        name: 'Warm Walnut Wood',
        image: asset('d3ac9c62856a541f_Warm%20Walnut%20Wood.png'),
      },
    ],
  },
  {
    type: 'Quartz',
    tagline: 'Engineered strength, refined finish',
    stones: [
      {
        name: 'Taj Mahal Natural',
        image: asset('x6qxkn5i_Taj%20Mahal%20Natural%20Cropped.png'),
      },
    ],
  },
  {
    type: 'Granite',
    tagline: 'Igneous resilience, enduring character',
    stones: [
      {
        name: 'Translucent Onyx with Luminous Amber Veins',
        image: asset('a9b125ad28b2872d_Translucent%20Onyx%20with%20Luminous%20Amber%20Veins.png'),
      },
    ],
  },
];
